<template>
<div class="chapter">
<div class="inner_page">
<p class="right"><a id="page_vi">Grenville Junior Division</a></p><a id="page_vi">
<p class="right">Britannia R.N. College</p>
<p class="right">Dartmouth</p>
<p class="right">Devon</p>
<p class="rightt">24/11/63</p>
<p class="noindentt">Dear Mum and Dad,</p>
<p class="noindentt">We had our mess dinner last Friday evening, but the news of President Kennedy stopped the usual high jinks afterwards. It was a very good meal though, and we all enjoyed it immensely. The news of Kennedy’s assassination came as a terrible shock to all of us here, and it was as if our own prime minister had died. The ensign was at half-mast till yesterday and the minesweeper in the harbour had her jack and ensigns all at half-mast. We all feel that we have lost a truly great person, and of course, it may well affect the Navy.</p>
<p class="center">***</p>
<p class="right">Hawke Division</p>
<p class="right">B. R. N. C.</p>
<p class="right">Dartmouth</p>
<p class="rightt">22. 10. 65</p>
<p class="noindentt">Last night, we had a mess dinner for Trafalgar Night, all kitted-up in our neck stranglers – stiff shirts and wing collars. Vice Admiral Law, the controller of the Navy, who’s in charge of ships construction and dockyards, was a guest at the dinner and gave a very good speech on Nelson.</p>
<p class="indent">This weekend, I’m going flying at Roborough, near Plymouth. The Tiger Moths are still going strong, though they are shortly being replaced by more modern training aircraft – the Chipmunks.</p>
<p class="center">***</p>
</a><p class="right"><a id="page_vi"></a><a id="page_vii">09/02/66</a></p><a id="page_vii">
<p class="noindentt">We’ve organised flying at Roborough for this half-term again, so I won’t be home. The rail strike looks as though it will be on, so it would be difficult anyway.</p>
<p class="center">***</p>
<p class="right">Officers’ Mess</p>
<p class="right">RAF Headley Court</p>
<p class="right">Nr Epsom</p>
<p class="right">Surrey</p>
<p class="rightt">8/9/66</p>
<p class="noindentt">A party of us have just returned from the Farnborough Air Show preview, which was very enjoyable. We saw the flying display from 2.30 till 5.00pm. The Navy made a good show with all the aircraft from the carrier HMS Hermes, and the Red Arrows RAF display team did their show, which was very impressive.</p>
<p class="center">***</p>
<p class="right">Wardroom</p>
<p class="right">Royal Naval Barracks</p>
<p class="right">Portsmouth</p>
<p class="rightt">23. 1. 67</p>
<p class="noindentt">The present course is loosely termed ‘Management’ and covers a variety of mainly clerical tasks for our future career. We are here in the Officers’ Divisional School learning about courts martial, naval law, pay regulations, ratings’ documents etc.</p>
<p class="indent">We all safely survived the air course and found it most interesting of all so far. Last week was all at Yeovilton, finishing off the course and taking exams. On Friday we visited Boscombe Down, the Aircraft and Armament Experimental Establishment, and saw every type of military aircraft in Britain – even a TSR 2, one of the flying prototypes.</p>
</a><p class="indent"><a id="page_vii"></a><a id="page_viii">The previous week was spent at Lossiemouth. We each had two flights from there – one in a Hawker Hunter, the other in a De Havilland Vampire – both very good value for seeing just what it’s like to fly in jets.</a></p><a id="page_viii">
<p class="center">***</p>
<p class="right">HMS Dryad</p>
<p class="right">Southwick</p>
<p class="right">Hampshire</p>
<p class="rightt">25. 10.67</p>
<p class="noindentt">All our work here has been concerned with the workings of a ship’s operations room. We all take turns at being captain – controlling fighter aircraft, manning radio links with other ships, and plotting on all types of radars and large perspex wall plots. I can now plot upside-down, sideways, backwards and almost in my sleep!</p>
<p class="center">***</p>
<p class="right">Central Flying School</p>
<p class="right">RAF Linton-on-Ouse</p>
<p class="right">York</p>
<p class="rightt">9th May 1969</p>
<p class="noindentt ">We’ve almost finished our flying now, and I’ve only got two flights to do – one of which is the final handling test. I’ve already taken and passed the final navigation and instrument flying test, both of which went quite well. The others on the course are just a bit behind me, but if we get good weather next week, we should be finished well within time.</p>
<p class="indent">Our passing-out ‘wings’ parade is on Friday 23rd May at 3.15pm and the evening dinner is at 7.30pm. I’ll send you invitations next week.</p>
<p class="right">Love to all,</p>
<p class="right">Steve</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm02.vue?58f4a7b4